import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useProductLineItems} from '../hooks/useProductLineItems.ts';
import {useParams} from "react-router-dom";

export const ReloadRecordsButton = () => {

    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('Product id is required');
    }

    const {fetchRecords} = useProductLineItems(productId);
    
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
